import {
  hasActionPermission,
  hasInputPermission,
} from '@tribeplatform/gql-client'
import { Form } from '@tribeplatform/react-sdk/components'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { PlanBadge } from '../../../PlanBadge'

export const WhiteLabelSettings = () => {
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()

  const { actionPermission } = hasActionPermission(
    network?.authMemberProps?.permissions ?? [],
    'updateNetwork',
  )
  const { authorized, requiredPlan } = hasInputPermission(
    actionPermission.inputPermissions,
    'input.tribeBranding',
  )

  return (
    <Card>
      <Card.Header
        title={
          <div className="flex items-center space-x-2">
            <div>White label</div>
            <div>
              <PlanBadge
                requiredPlanName={requiredPlan}
                authorized={authorized}
              />
            </div>
          </div>
        }
      />
      <Card.Content>
        <Form
          defaultValues={network}
          onSubmit={async data => {
            const { tribeBranding } = data
            try {
              await updateNetwork({
                input: {
                  tribeBranding,
                },
              })
              toast({
                title: 'White label settings updated',
                status: 'success',
              })
            } catch (e) {
              toast({
                title: 'Unable to update white label settings',
                status: 'error',
              })
            }
          }}
        >
          <div className="col-span-12 md:col-span-8 flex flex-col space-y-5">
            <Form.Toggle
              name="tribeBranding"
              label="Display Tribe branding"
              description="Display a “Powered by Tribe” badge on the community navigation and email footers"
              disabled={!authorized}
            />
            <Form.Actions>
              <Button type="submit" loading={isLoading} disabled={!authorized}>
                Update
              </Button>
            </Form.Actions>
          </div>
        </Form>
      </Card.Content>
    </Card>
  )
}
